<template>
  <v-layout row wrap>
    <v-flex :class=" mini ? 'p-5 xs12 sm6 md4 lg4' : 'p-5 xs12 sm12 md6 lg6'">
      <v-card class="elevation-5 mb-3">
        <v-card-title class="justify-center">
          <h3>Last 6 Days</h3>
        </v-card-title>
        <v-divider class="mb-5"></v-divider>
        <line-chart v-if="chartLabelsDay.length > 0 && chartDataDay.length > 0" :chartData="chartDataDay" :chartLabels="chartLabelsDay" class="chartbox"></line-chart>
        <v-progress-circular v-else indeterminate :width="3" :size="100" color="#82ca9d" class="ma-5"></v-progress-circular>
      </v-card>
    </v-flex>
    <v-flex :class=" mini ? 'p-5 xs12 sm6 md4 lg4' : 'p-5 xs12 sm12 md6 lg6'">
      <v-card class="elevation-5 mb-3">
        <v-card-title class="justify-center">
          <h3>Last 6 Months</h3>
        </v-card-title>
        <v-divider class="mb-5"></v-divider>
        <line-chart v-if="chartLabelsMonth.length > 0 && chartDataMonth.length > 0" :chartData="chartDataMonth" :chartLabels="chartLabelsMonth" class="chartbox"></line-chart>
        <v-progress-circular v-else indeterminate :width="3" :size="100" color="#82ca9d" class="ma-5"></v-progress-circular>
      </v-card>
    </v-flex>
    <v-flex :class=" mini ? 'p-5 xs12 sm6 md4 lg4' : 'p-5 xs12 sm12 md6 lg6'">
      <v-card class="elevation-5 mb-3">
          <v-card-title class="justify-center">
          <h3>Last 6 Years</h3>
        </v-card-title>
        <v-divider class="mb-5"></v-divider>
        <line-chart v-if="chartLabelsYear.length > 0 && chartDataYear.length > 0" :chartData="chartDataYear" :chartLabels="chartLabelsYear" class="chartbox"></line-chart>
        <v-progress-circular v-else indeterminate :width="3" :size="100" color="#82ca9d" class="ma-5"></v-progress-circular>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LineChart from './../LineChart.js'
import axios from '@/helpers/axios'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Chart',
  components: {
    LineChart
  },
  data () {
    return {
      toggle_exclusive: 1,
      chartLabelsDay: [],
      chartDataDay: [],
      chartLabelsMonth: [],
      chartDataMonth: [],
      chartLabelsYear: [],
      chartDataYear: []
    }
  },
  computed: {
    ...mapState([
      'idClient',
      'token',
      'mini'
    ])
  },
  methods: {
    setDays (obj) {
      let data = []
      obj.map(val => {
        data.push(moment(val).format('dddd').substr(0, 3))
      })
      return data
    },
    getTotalTrans () {
      this.$emit('loading', true)

      let dataBody = {
        id_client: this.idClient
      }

      axios.defaults.headers = {
        accesstoken: this.token
      }

      let url = '/total_transaction'

      axios.post(url, dataBody)
        .then(response => {
          let self = this
          let resObj = response.data.data

          self.chartLabelsDay = self.setDays(Object.keys(resObj.perhari))
          self.chartDataDay = Object.values(resObj.perhari)
          self.chartLabelsMonth = Object.keys(resObj.perbulan)
          self.chartDataMonth = Object.values(resObj.perbulan)
          self.chartLabelsYear = Object.keys(resObj.pertahun)
          self.chartDataYear = Object.values(resObj.pertahun)
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.$emit('text', error.response.data.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    }
  },
  mounted () {
    this.getTotalTrans()
  }
}
</script>

<style scoped>
.chartbox {
  min-height: 30rem;
}

.p-5 {
  padding: 5px;
}

.v-btn-toggle .v-btn.v-btn--active {
  background: #82ca9d;
  color: white;
}

@media only screen and (max-width: 500px) {
  .v-btn-toggle {
    flex-direction: column;
  }
  .toggle-box {
    width: 100%!important
  }
}

@media only screen and (min-width: 500px) {
  .v-btn-toggle {
    flex-direction: row;
  }
}
</style>
